import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-3" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link active",
      id: "zandaka-tab",
      "data-toggle": "tab",
      "aria-selected": "true",
      href: "#zandaka-setting",
      role: "tab",
      "aria-controls": "zandaka-setting"
    }, "期首残高科目")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "junsoneki-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#junsoneki-setting",
      role: "tab",
      "aria-controls": "junsoneki-setting"
    }, "純損益科目")
  ])
], -1)
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "zandaka-setting",
  role: "tabpanel",
  "aria-labelledby": "zandaka-tab"
}
const _hoisted_6 = {
  class: "tab-pane fade",
  id: "junsoneki-setting",
  role: "tabpanel",
  "aria-labelledby": "junsoneki-tab"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_junsoku_setting_title = _resolveComponent("junsoku-setting-title")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_setting_panel = _resolveComponent("setting-panel")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _createVNode(_component_junsoku_setting_title, { "main-title": "純資産明細表" })
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_loading_button, {
          color: "primary",
          onClick: _ctx.onClickRegister,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedResponse,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_setting_panel, {
              "response-setting-item": _ctx.state.setting.zandaka,
              onUpdateSettingItem: _ctx.onUpdatedSetting,
              "panel-name": "zandaka"
            }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_setting_panel, {
              "response-setting-item": _ctx.state.setting.junsoneki,
              onUpdateSettingItem: _ctx.onUpdatedSetting,
              "panel-name": "junsoneki"
            }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}